import { Link } from "react-router-dom";
import logo from "../assets/favicon.png";

const Header = () => {
  return (
    <div>
      <header className="text-gray-400 bg-slate-900">
        <div className="container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center">
          <div className="flex title-font font-medium items-center text-white mb-4 md:mb-0">
            <Link to="/" className="ml-3 font-sacramento font-bold">
              <img src={logo} alt="" height={100} width={100} />
            </Link>
          </div>
          <nav className="md:ml-auto md:mr-auto flex flex-wrap items-center justify-center font-delius font-bold text-md">
            <Link to="/" className="mr-5 hover:text-white">
              Home
            </Link>
            <Link to="/contributors" className="mr-5 hover:text-white">
              Contributors
            </Link>
            <Link to="/blogs" className="mr-5 hover:text-white">
              Blogs
            </Link>
            <Link to="/contact" className="mr-5 hover:text-white">
              Contact
            </Link>
          </nav>
          <button className="inline-flex items-center bg-gray-800 border-0 py-1 px-3 focus:outline-none hover:bg-gray-700 rounded invisible md:visible text-base mt-4 md:mt-0 display-none">
            <a href="https://github.com/GREEN-UNIVERSITY-OF-BANGLADESH/problem-solving" className="font-delius font-bold">Github</a>
            <svg
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              className="w-4 h-4 ml-1"
              viewBox="0 0 24 24"
            >
              <path d="M5 12h14M12 5l7 7-7 7"></path>
            </svg>
          </button>
        </div>
      </header>
    </div>
  );
};

export default Header;